import { useMemo } from "react";
import { usePropertyApiClient } from "../../property/services/usePropertyApiClient";
import { createPartnerTeamService } from "../services/partnerTeamService";

export const useTeamService = () => {
  const apiClient = usePropertyApiClient();
  return useMemo(() => createPartnerTeamService(apiClient), [apiClient]);
};
